import http, { HttpSuccessOrErrorType } from '../http'

export default {

    /**
     * 还原软删除员工
     * @param ids 
     * @returns 
     */
    async patch_restore_delete_staff(ids: string[]): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch('/restore/delete/staff', {
            _ids: ids
        })
    },

    /**
     * 还原软删除餐馆
     * @param ids 
     * @returns 
     */
    async patch_restore_delete_restaurant(ids: string[]): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch('/restore/delete/restaurant', {
            _ids: ids
        })
    },

    /**
     * 还原软删除集团
     * @param groups 
     * @returns 
     */
    async patch_restore_delete_group(
        groups: {
            _id: string;
            //true：还原集团下的餐馆和员工；反之不还原
            is_restore_staff_restaurant: boolean
        }[]
    ): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch('/restore/delete/group', {
            groups
        })
    },

    /**
     * 还原软删除经销商
     * @param groups 
     * @returns 
     */
    async patch_restore_delete_reseller(
        ids: string[],
        //true：还原经销商集团、餐馆和员工；反之不还原
        is_restore_staff_restaurant: boolean

    ): Promise<HttpSuccessOrErrorType<any>> {
        return await http.patch('/restore/delete/reseller', { _ids: ids, is_restore_staff_restaurant })
    },
}